export default __webpack_public_path__ + "static/media/wall.051f29d3.png";